let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("19lKy")).then(() => parcelRequire('il93n'));